import { safeFetchAPI, SafeFetchResponse } from '../index'
import {
  PendingReviewsResponse,
  CompletedReviewsResponse,
  SubmitReviewRequest,
  SubmitReviewResponse,
  MenuType,
} from '../../types/widget'
import { API_BASE } from './index'

type ReviewsQueryParams = {
  storeID?: string
  menuType?: MenuType
  globalId?: string
}

function toQueryParams(input?: ReviewsQueryParams): Record<string, string> {
  const params: Record<string, string> = {}
  if (input?.storeID) params.storeID = input.storeID
  if (input?.menuType) params.menuType = input.menuType
  if (input?.globalId) params.globalId = input.globalId
  return params
}

/**
 * `pii` is the raw phone or email the shopper signed in with. It goes into
 * the URL path; server normalizes both the URL param and the JWT identity
 * claim before comparison. The JWT is passed via `authToken` which becomes
 * `Authorization: Bearer <token>`.
 */
function encodePii(pii: string): string {
  return encodeURIComponent(pii.trim())
}

export async function getPendingReviews(
  uid: string,
  pii: string,
  token: string,
  queryParams?: ReviewsQueryParams
): Promise<SafeFetchResponse<PendingReviewsResponse>> {
  return safeFetchAPI<PendingReviewsResponse>(
    `${API_BASE}/widget/reviews/pending/${uid}/${encodePii(pii)}`,
    {
      authToken: token,
      queryParams: toQueryParams(queryParams),
    }
  )
}

export async function getCompletedReviews(
  uid: string,
  pii: string,
  token: string,
  queryParams?: ReviewsQueryParams
): Promise<SafeFetchResponse<CompletedReviewsResponse>> {
  return safeFetchAPI<CompletedReviewsResponse>(
    `${API_BASE}/widget/reviews/completed/${uid}/${encodePii(pii)}`,
    {
      authToken: token,
      queryParams: toQueryParams(queryParams),
    }
  )
}

export async function submitReview(
  uid: string,
  pii: string,
  token: string,
  payload: SubmitReviewRequest,
  queryParams?: ReviewsQueryParams
): Promise<SafeFetchResponse<SubmitReviewResponse>> {
  return safeFetchAPI<SubmitReviewResponse>(
    `${API_BASE}/widget/reviews/${uid}/${encodePii(pii)}`,
    {
      method: 'POST',
      payload,
      authToken: token,
      queryParams: toQueryParams(queryParams),
    }
  )
}
